import type { SVGProps } from "react";

const DashboardIcon = ({
  width = 30,
  height = 30,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M2 14.755c0-2.86 0-4.29.649-5.477.649-1.185 1.835-1.921 4.206-3.393l2.5-1.551C11.862 2.778 13.115 2 14.5 2c1.385 0 2.638.778 5.145 2.334l2.5 1.551c2.371 1.472 3.557 2.208 4.206 3.393.649 1.186.649 2.616.649 5.477v1.901c0 4.876 0 7.314-1.465 8.83C24.072 27 21.714 27 17 27h-5c-4.714 0-7.071 0-8.536-1.515C2 23.97 2 21.532 2 16.656v-1.901Z"
    />
    <path
      fill="#7B7B7B"
      d="M10.041 18a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v9h-9v-9Z"
    />
  </svg>
);
export default DashboardIcon;
